import { render, staticRenderFns } from "./yqg-footer.vue?vue&type=template&id=09e1d263&scoped=true&"
import script from "./yqg-footer.js?vue&type=script&lang=js&"
export * from "./yqg-footer.js?vue&type=script&lang=js&"
import style0 from "./yqg-footer.scss?vue&type=style&index=0&id=09e1d263&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e1d263",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09e1d263')) {
      api.createRecord('09e1d263', component.options)
    } else {
      api.reload('09e1d263', component.options)
    }
    module.hot.accept("./yqg-footer.vue?vue&type=template&id=09e1d263&scoped=true&", function () {
      api.rerender('09e1d263', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/snxguarantee/index/component/yqg-footer/yqg-footer.vue"
export default component.exports